import z from 'zod';

export const firestoreTimestampCreatorSchema = z.custom<{
  _methodName: 'serverTimestamp';
}>((value) => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  return (value as {_methodName?: unknown})._methodName === 'serverTimestamp';
});

export type FirestoreTimestampCreator = z.infer<typeof firestoreTimestampCreatorSchema>;
